import axios from 'axios';

const  URL = 'https://api.openweathermap.org/data/2.5/weather';
const API_KEY = 'ba32a543a98aa776ce12a66c81f51629';

export const fetchWeather =  async (query) => {
     const { data } = await axios.get(URL, {
         params: {
             q: query,
             units: 'metric',
             APPID: API_KEY,
         }
     });

     return data;
 }